import { useState } from "react";
import { Link } from "react-router";
import { useMe } from "../app/services";
import { Icon } from "./Icon";

export const GUIDE_KEY = "hororiba-record:guide-v1";
export function guideSeen() {
  try { return localStorage.getItem(GUIDE_KEY) === "seen"; } catch { return false; }
}
export function rememberGuide() {
  try { localStorage.setItem(GUIDE_KEY, "seen"); } catch { /* Storage may be disabled. */ }
}

/** A dismissible invitation, never a modal over playback controls. */
export function WelcomeGuide() {
  const me = useMe();
  const [dismissed, setDismissed] = useState(guideSeen);
  if (!me || dismissed) return null;
  return <aside className="welcome-guide" aria-label="初めての方へ">
    <Icon name="sparkle" />
    <div><strong>はじめまして、ほろりばレコードです。</strong>
      <p>Discordで聴いて、好きな瞬間を残そう。4つのステップでご案内します。</p>
      <Link to="/guide" className="welcome-guide__link">使い方を見てみる →</Link>
    </div>
    <button type="button" className="icon-btn" aria-label="初回の案内を閉じる" onClick={() => {
      rememberGuide(); setDismissed(true);
    }}><Icon name="close" /></button>
  </aside>;
}
